import i18n from '../../i18n';
import { normalizeRichTextLink } from './richTextLink';

export default [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  [{ header: 1 }, { header: 2 }], // custom button values
  [{ 'color': [] }, { 'background': [] }],
  [{ list: "ordered" }, { list: "bullet" }],
  ['link'],
  ['clean']
];

export function configureQuillLinks(editor) {
  const button = editor.getModule('toolbar').container.querySelector('.ql-link');
  button.setAttribute('aria-label', i18n.t('richTextEditor.insertLink'));
  button.setAttribute('title', i18n.t('richTextEditor.insertLink'));
  // Guard Snow's Save path so both new links and the existing-link Edit action
  // use the same validation, including saving with Enter.
  const tooltip = editor.theme.tooltip;
  const save = tooltip.save;
  tooltip.save = function() {
    if (this.root.getAttribute('data-mode') === 'link') {
      const link = normalizeRichTextLink(this.textbox.value);
      if (!link) {
        window.alert(i18n.t('richTextEditor.invalidLink'));
        this.textbox.focus();
        return;
      }
      this.textbox.value = link;
    }
    return save.call(this);
  };
}
